export default {
  /**查询账套列表 */
  GET_LIST_LEDGERS: '/maindata/ledger/listLedgers',
  /**查询币种 */
  GET_LIST_CURRENCY: '/maindata/currency/listCurrency',
  /**查询日历*/
  SEARCH_LISTACCOUNTCALENDARS: '/maindata/accountCalendar/listAccountCalendars',
  // 查询公司
  LISTDATA_SERECHCOMPANY: '/maindata/company/listCompanyByTenantCode',
  //创建账套
  ADD_LEDGER: '/maindata/ledger/addLedger',
  //查询详情
  GET_LEDGER_DETAIL: '/maindata/ledger/getLedgerDetail',
  //保存
  UPDATE_LEDGER: '/maindata/ledger/updateLedger',
  //已关联账套的法人主体
  LIST_ALL_LEDGER_LEGAL_ENTITY: '/maindata/ledger/listAllLedgerLegalEntity',
  //字典表
  LISTDATA_DICTBYDATACODE: '/maindata/dictData/listDataDictByDataType',
};
